import { useEffect, useState } from "react";
import apiClient from "../../components/utils/apiClient";
import RequestsTable from "../../components/requests/RequestsTable";
import { useTranslation } from "react-i18next";

const RequestsHistory = ({vendorId,setIsActionLoading}) => {
    const {t} = useTranslation();

    const [requests, setRequests] = useState(null);

    const getRequests = async () => {
        try {
          const response = await apiClient.get(`/requests/vendor-requests?skip=0&vendorsId=${vendorId}`);
          if(response?.data) {
            setRequests(response?.data);
          } else {

          }
          setIsActionLoading(false);
        } catch(err) {setIsActionLoading(false);}
    }

    useEffect(()=>{
        setIsActionLoading(true);
    },[])

    useEffect(()=>{
      if(vendorId) {
        getRequests();
      }
    },[vendorId])


    return (
        <>
        {requests && (Array.isArray(requests) && requests?.length > 0 ? <div className="w-full overflow-x-auto"><RequestsTable requests={requests} type="history" /></div>
        : <div className="text-center w-full max-w-[500px] mx-auto pt-[156px] font-[500] text-[24px] text-grey-900">
            <img src="/assets/images/no-requests.svg" alt="" className="w-[188px] h-[188px] mb-[24px] mx-auto" />
            {t('requests.noPreviousRequests')}
            </div>
        )}
        </>);
}
export default RequestsHistory;
